/**
 * 動的なスタイル操作
 */

// 最下部フッターが存在する場合のメインコンテンツの最大heightを返却
export function getMaxMainContentsHeight(footerHeight: number) {
  return `calc(100vh - var(--header-height) - (var(--container-main-contents-margin) * 2) - ${footerHeight}px)`;
}
